import type { MaybeElementRef } from "@vueuse/core";
import { useEventOutside } from "./onEventOutside";

interface OnPointerDownOutside {
  ignore?: (MaybeElementRef | string)[];
}

export function onPointerDownOutside(
  target: MaybeElementRef,
  handler: (event: PointerEvent) => void,
  options: OnPointerDownOutside = {},
) {
  useEventOutside(target, "pointerdown", handler, options);
}
